// Pet industry tokens ("Petopia"). Warm chocolate, light brown, and golden palette.
import { baseTokens } from '../_base/tokens.js';

export const petTokens = {
  ...baseTokens,
  token: {
    ...baseTokens.token,
    colorPrimary: '#875056',
    colorInfo: '#875056',
    colorLink: '#875056',
    colorPrimaryHover: '#9b5f55',
    colorLinkHover: '#9b5f55',
    colorPrimaryActive: '#5b3430',
    colorWarning: '#f6ab45',
    borderRadius: 12,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  components: {
    ...baseTokens.components,
    Card: { borderRadiusLG: 16 },
    Button: { borderRadius: 999 },
  },
};
